import type { SimilarFreelancers } from './similar-freelancers.model';
import type { Skill } from '../skills/skills.model';
import { phpSkill, snakeCase } from '../skills/skills.seed';

export interface GenerateSimilarFreelancersOptions {
  readonly userId: number;
  readonly skills?: readonly Skill[];
}

export function generateSimilarFreelancersObject({
  userId,
  skills = [phpSkill()],
}: GenerateSimilarFreelancersOptions): SimilarFreelancers {
  return {
    id: userId,
    tags: skills.map(skill => ({
      url: `/freelancers/skills/${snakeCase(skill.seoUrl)}`,
      label: skillNameToLabel(skill),
    })),
  };
}

function skillNameToLabel(skill: Skill): string {
  switch (skill.name) {
    case 'PHP': {
      return 'PHP Developer';
    }
    case 'Python': {
      return 'Python Developer';
    }
    case 'Website Design': {
      return 'Website Designer';
    }
    case 'Graphic Design': {
      return 'Graphic Designer';
    }
    case 'Translation': {
      return 'Translator';
    }
    case 'Photography': {
      return 'Photographer';
    }
    case 'Logo Design': {
      return 'Logo Designer';
    }
    default:
      throw new Error(`Cannot convert skill ${skill.name} to label`);
  }
}
